import React, { useEffect } from "react";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { useMachine } from "@xstate/react";
import { createMachine } from "xstate";

import { actions } from "./actions";
import { MACHINE_CONFIG } from "./config";
import { services } from "./services";

export const activateUserContext = React.createContext({});
export let activateUserMachine: any;

const MODULE_NAME = "machines.activateUser";
const log: any = LoggerModule?.getInstance();

export const useSMActivateUser = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  activateUserMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(activateUserMachine);

  return {
    activateUserMachine,
    activateUserState: state,
    activateUserSend: send,
  };
};
